import React from 'react';
import { ShoppingBagIcon, FileTextIcon, SyringeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const ACTIONS = [{
  title: 'Shop Over-The-Counter',
  icon: <ShoppingBagIcon className="w-6 h-6" data-id="element-244" data-mp="zpu2iprgsxvg" />,
  link: '/otc-products',
  image: 'https://images.unsplash.com/photo-1586015555751-63bb77f4322a?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Transfer Your Prescription',
  icon: <FileTextIcon className="w-6 h-6" data-id="element-245" data-mp="74aqi5z1fuff" />,
  link: '/transfer-prescription',
  image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbbb88?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Check Vaccine Availability',
  icon: <SyringeIcon className="w-6 h-6" data-id="element-246" data-mp="c11ctb1frm9a" />,
  link: '/immunizations',
  image: 'https://images.unsplash.com/photo-1632345031435-8727f6897d53?q=80&w=800&auto=format&fit=crop'
}];
export function QuickActions() {
  return <section className="py-12 sm:py-16 bg-clean-grey" data-id="element-247" data-mp="1nfy8h3s4l9pm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-248" data-mp="2ceojtmyv3vj9">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg sm:text-xl font-bold text-slate-900 mb-8 sm:mb-10 text-center uppercase tracking-widest" data-id="element-249" data-mp="2cgj4d0681lmt">
          What would you like to do today?
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-4 sm:gap-6" data-id="element-250" data-mp="1ymic8p9rywvf">
          {ACTIONS.map((action, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} data-id="element-251" data-mp="23lbf7nrfr5hc" data-mpi={idx}>
              <Link to={action.link} className="bg-white rounded-xl border border-slate-200 flex flex-col items-center text-center hover:shadow-md transition-shadow cursor-pointer group h-full overflow-hidden" data-id="element-252" data-mp="17v2p6qzvyi6o">
                <div className="w-full aspect-[16/9] overflow-hidden" data-id="element-253" data-mp="1hngt9qefs0w0">
                  <img src={action.image} alt={action.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg';
              }} data-id="element-254" data-mp="1cmt6xi15k884" />
                </div>
                <div className="p-6 sm:p-10 flex flex-col items-center" data-id="element-255" data-mp="2ac60m76352g7">
                  <div className="text-clinical-blue mb-4 sm:mb-6 group-hover:scale-110 transition-transform" data-id="element-256" data-mp="25a6wuw6fo3iq">
                    {action.icon}
                  </div>
                  <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wide" data-id="element-257" data-mp="2hu3vp6nisazw">
                    {action.title}
                  </h3>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}